// Header.js
import React from "react";
import { useCallback, useEffect, useReducer, useRef, useState } from "react";
import { Image, StyleSheet, Text, View } from "react-native";
import LogoIcon from "components/assets/favicon.png";
import MainMenu from "components/Partials/MainMenu";

const Header = ({}) => {
	const _theme = window.main.theme;

	const styles = {

		headerOuter: {
			alignItems: "center",
			alignSelf: "stretch",
			backgroundColor: _theme.colors.mode.backgroundColor,
			borderBottomColor: _theme.colors.successDark,
			borderBottomWidth: 2,
			cursor: "auto",
			flexDirection: "row",
			flexGrow: 1,
			height: 60,
			maxHeight: 60,  // /!\ Fixes weight bug on Adroid when keyboard is showing/hidden.
			justifyContent: "center",
			pointerEvents: "auto",

			zIndex: 9996,
		},

		header: {
			alignSelf: "stretch",
			alignItems: "center",
			display: "flex",
			flexDirection: "row",
			flexGrow: 1,
			height: 60,
			justifyContent: "center",
			maxWidth: 1400,
			position: "relative",
		},
		headerLogoWrapper: {
			alignItems: "center",
			display: "flex",
			flexDirection: "row",
			justifyContent: "center",
		},
		headerLogo: {
			height: 20,
			width: 20,
			marginRight: 5,
		},
		text: {
			color: _theme.colors.mode.textColor,
			// color: window.main.theme.colors.emph,
			fontSize: 20,
			textAlign: "center",
			marginLeft: 10,
		},
	};

	useEffect(()=>{
		// Simply having this here causes the component to refresh and that allows 'process.env.REACT_APP_APPTITLE' to display its correct value.
	},[]);

	return (
		<View style={styles.headerOuter}>
			<View style={styles.header}>
				<View style={{...styles.headerLogoWrapper}}>
					<Image nativeID={"brand_logo"} style={{...styles.headerLogo,marginRight:6}} source={LogoIcon} resizeMode={"cover"} accessibilityLabel={"VetManaged Logo"} />
					<Text nativeID={"app_title"} style={{...styles.headerTitle,whiteSpace:"nowrap"}}> {process.env.REACT_APP_APPTITLE}</Text>
				</View>
				<View style={{position:"absolute",top:10,right:0,borderTopLeftRadius:14,borderBottomLeftRadius:14,paddingLeft:10,paddingBottom:10}}>
					<MainMenu />
				</View>
			</View>
		</View>
	);

};

export default Header;
